// extracted by mini-css-extract-plugin
export default {"contact":"styles_contact__z-Hbq","contact__firstp":"styles_contact__firstp__+5tPb","contact__btn":"styles_contact__btn__MatAS"};